import { render, staticRenderFns } from "./SMultiSel.vue?vue&type=template&id=1d80a636"
import script from "./SMultiSel.vue?vue&type=script&lang=js"
export * from "./SMultiSel.vue?vue&type=script&lang=js"
import style0 from "./SMultiSel.vue?vue&type=style&index=0&id=1d80a636&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports